import '../index.css';
import { motion } from "framer-motion";
import { useState } from "react";
import s1 from "../Components/banner/spiritual.jpg";
import s from "../Components/banner/holy spiroro.jpg";
import c1 from "../Components/banner/criown him.jpg";
import c from "../Components/banner/kingon.jpg";

const yearlyEvents = [
    {
        id: 1,
        month: "April",
        period: "Easter Monday",
        title: "Outpouring of the Holy Spirit",
        short: "Annual spiritual renewal where brethren assemble before the Holy Father to have the Holy Spirit revived within them.",
        full: [
            "On every Easter Monday of the year, it is a common practice in Brotherhood of the Cross and Star (BCS) that all faithful assemble before The Holy Father at the BCS World Headquarters, 34 Ambo Great Hall, to have The Holy Spirit in them revived by The Holy Spirit personified, Leader Olumba Olumba Obu Himself.",
            "This annual spiritual exercise is to reawaken their spirits and bodies, keeping them fit, emboldened, and empowered for the Great Commission. This is in fulfillment of the ancient scriptural prophecies.",
            "'I will pour out of my Spirit upon all flesh: and your sons and your daughters shall prophesy, and your young men shall see visions, and your old men shall dream dreams.' (Acts 2:16-18).",
            "The outpouring of the Holy Spirit is the high point of the April (Easter) Pentecostal period; thus, its significance cannot be overemphasized. It is an event during which the brethren's sins are cleansed, their flesh mortified, and their souls infused with the Holy Spirit of God.",
        ],
        images: [s1, s],
        ref: "Acts 2:16-18 · John 20:21-23 · Joel 2:28-29",
        color: "blue",
    },
    {
        id: 2,
        month: "April / November",
        period: "Divine Coronation",
        title: "The King of Kings and Lord of Lords Coronation",
        short: "A monumental two-phase event marking the divine coronation of His Holiness Olumba Olumba Obu as King of Kings.",
        full: [
            "The coronation of the King of kings and Lord of lords, His Holiness Olumba Olumba Obu was a monumental event that took place in two strata.",
            "Sunday, the 26th day of November 2000 — The Sole Spiritual Head of the Universe, Leader Olumba Olumba Obu revealed the greatest mystery in the Brotherhood. This was the identity of the Head of Administration, BCS Worldwide.",
            "This glory was fulfilled when the Ancient of Days crowned His first begotten son, His Holiness Olumba Olumba Obu in the Holiest of Holies, after the historic homecoming visit of the King, tagged 'Home Mission 2000'.",
            "On Saturday, the 14th day of April 2001, this scripture was fulfilled, as the Holy Father crowned His First Begotten yet again, before the entire universe. The word of God is yes and amen!",
            "The Divine Coronation of the King of kings and Lord of lords before the entire universe marked a crucial turning point in the affairs of the earth man, and the commencement of the Government of God on earth, Theocracy.",
        ],
        images: [c1, c],
        ref: "Daniel 7:13-14 · John 17:5 · Hebrew 1:6",
        color: "red",
    },
    {
        id: 3,
        month: "Annually",
        period: "Supreme Signature Day",
        title: "Supreme Signature",
        short: "Marking the supreme authority of the King of Kings as Chairman BCS Executive Council and Head of Administration worldwide.",
        full: [
            "It marks the supreme authority of the King of Kings and Lord of Lords. He is the Chairman BCS Executive Council and Head of Administration, BCS worldwide. He is also the head of the Unified Universal Theocratic Government.",
            "Whatever He appends the signature remains sacrosanct. He is the highest authority every spirit submits to.",
        ],
        images: [],
        ref: "Matthew 28:18",
        color: "blue",
    },
    {
        id: 4,
        month: "August 8",
        period: "Annual",
        title: "Eton Day",
        short: "Celebrating the day BCS was revealed to the entire universe when members first marched in their heavenly robes from Eton Street.",
        full: [
            "The annual 8 Eton day celebration is of very great significance. Eton Street, Calabar, Cross River State is where Supreme Holy Father Leader Olumba Olumba Obu started BCS.",
            "On the 8th day of August, 1958, Brotherhood of the Cross and Star was revealed to the entire universe because it was the first day ever, the members of BCS dressed in the heavenly robe (soutane) and marched from the street of Eton to 26 Mbukpa Road, Calabar, Cross River State, signifying the movement of the kingdom to a greater height.",
        ],
        images: [],
        ref: "Est. August 8, 1958",
        color: "red",
    },
    {
        id: 5,
        month: "Annually",
        period: "Holy Mother's Day",
        title: "Holy Mother's Glorification",
        short: "Honouring the Holy Mother — the pillar, backbone and building rock of BCS whose love for humanity is incomparable.",
        full: [
            "The day the Holy Mother was transformed will remain evergreen in the minds and souls of every true BCS member. The reason the day is remembered in BCS.",
            "Holy Mother was the pillar, backbone and building rock of BCS. She is the reason the kingdom is spreading fast and wide. She is the epitome of blessedness; her love and mercy for humanity is incomparable.",
        ],
        images: [],
        ref: "In Honour of the Holy Mother",
        color: "blue",
    },
    {
        id: 6,
        month: "November 20",
        period: "Annual",
        title: "Divine Manifestation of King of Kings and Lord of Lords",
        short: "Celebrating the birth of His Holiness Olumba Olumba Obu — the reincarnated Christ who came to rule and judge the universe.",
        full: [
            "Just like Christmas day is celebrated to mark the birth of our Lord Jesus Christ, this day is celebrated and will always be celebrated forever in Brotherhood of the Cross and Star.",
            "It is the day which the glorious King of Heaven and the reincarnated Christ, His Holiness Olumba Olumba Obu, was brought into the earth again to rule and judge the entire universe.",
            "High points of the event are the banquet on 19th November which is called 'The Feast of the Lamb'.",
        ],
        images: [],
        ref: "Matthew 28:18 · Revelation 19:16",
        color: "red",
    },
    {
        id: 7,
        month: "December 30",
        period: "Annual",
        title: "Divine Manifestation of the Ancient of Days",
        short: "Celebrating the physical manifestation of Leader Olumba Olumba Obu on 30th December 1918 in Biakpan, Cross River State.",
        full: [
            "Leader Olumba Olumba Obu, The Sole Spiritual Head of the Universe, is the Founder, Leader, and Sustainer of the Brotherhood of the Cross and Star Kingdom. His mission on earth is to do what nobody, angel or spirit has ever done in the world.",
            "He came to teach and lead man into God's Kingdom, to sanctify humanity, to establish the Kingdom of God on Earth. His Physical Manifestation was on 30th December, 1918, in a little town of Biakpan, in Cross River State, Nigeria.",
            "Leader Olumba Olumba Obu has remained energetic and the propelling force behind the proliferation of the Brotherhood of the Cross and Star. That is why every 30th day of December is very significant in Brotherhood of the Cross and Star.",
        ],
        images: [],
        ref: "December 30, 1918 · Biakpan, Cross River State",
        color: "blue",
    },
    {
        id: 8,
        month: "Annually",
        period: "Award Night",
        title: "Music & Merit Award Night",
        short: "A celebration of excellence, talent and dedication within the Brotherhood of the Cross and Star worldwide.",
        full: [
            "Brotherhood of the Cross and Star is a global divine institution. It teaches and practices Universal love, peace, unity, truth and righteousness in the Holy Spirit.",
            "The World Headquarters (WHQ) of Brotherhood of the Cross and Star situates at No 34 Ambo Street Calabar, Nigeria West Africa.",
        ],
        images: [],
        ref: "BCS World Headquarters, Calabar",
        color: "red",
    },
];

const colorMap = {
    blue: {
        dot: "bg-blue-600",
        border: "border-blue-100",
        tag: "bg-blue-50 text-blue-600 border-blue-200",
        heading: "text-blue-600",
        btn: "bg-blue-600 hover:bg-blue-700",
        line: "bg-blue-100",
    },
    red: {
        dot: "bg-red-600",
        border: "border-red-100",
        tag: "bg-red-50 text-red-600 border-red-200",
        heading: "text-red-600",
        btn: "bg-red-600 hover:bg-red-700",
        line: "bg-red-100",
    },
};

function EventCard({ event, index }) {
    const [expanded, setExpanded] = useState(false);
    const c = colorMap[event.color];
    const isEven = index % 2 === 0;

    return (
        <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.5, delay: index * 0.05 }}
            className={`relative flex flex-col md:flex-row ${isEven ? "" : "md:flex-row-reverse"} gap-0 mb-16`}
        >
            {/* Timeline spine dot */}
            <div className="hidden md:flex flex-col items-center absolute left-1/2 -translate-x-1/2 top-0 bottom-0 z-10">
                <div className={`w-4 h-4 rounded-full ${c.dot} mt-1 flex-shrink-0`} />
                <div className={`flex-1 w-px ${c.line}`} />
            </div>

            {/* Card */}
            <div className={`md:w-[46%] ${isEven ? "md:pr-12" : "md:pl-12"}`}>
                <div className={`border ${c.border} rounded-sm p-6`}>

                    {/* Tag + period */}
                    <div className="flex items-center gap-2 mb-3">
                        <span className={`text-[9px] font-bold tracking-widest uppercase border px-2 py-0.5 rounded-sm ${c.tag}`}>
                            {event.period}
                        </span>
                        <span className="text-[9px] text-gray-400 tracking-widest uppercase font-semibold">
                            {event.month}
                        </span>
                    </div>

                    {/* Title */}
                    <h3 className={`text-lg font-bold leading-snug mb-2 ${c.heading}`}>
                        {event.title}
                    </h3>

                    {/* Short desc */}
                    <p className="text-gray-500 text-sm leading-relaxed mb-4">
                        {event.short}
                    </p>

                    {/* Expanded content */}
                    {expanded && (
                        <motion.div
                            initial={{ opacity: 0, height: 0 }}
                            animate={{ opacity: 1, height: "auto" }}
                            transition={{ duration: 0.35 }}
                            className="overflow-hidden"
                        >
                            <div className={`w-full h-px ${c.line} mb-4`} />
                            <div className="space-y-3 mb-4">
                                {event.full.map((para, i) => (
                                    <p key={i} className="text-gray-600 text-sm leading-relaxed">
                                        {para}
                                    </p>
                                ))}
                            </div>

                            {/* Images if any */}
                            {event.images.length > 0 && (
                                <div className={`grid ${event.images.length > 1 ? "grid-cols-2" : "grid-cols-1"} gap-3 mb-4`}>
                                    {event.images.map((img, i) => (
                                        <img
                                            key={i}
                                            src={img}
                                            alt={event.title}
                                            className="w-full h-44 object-cover object-center rounded-sm"
                                        />
                                    ))}
                                </div>
                            )}

                            {/* Scripture ref */}
                            <p className="text-[10px] text-gray-400 italic tracking-wide border-t border-gray-100 pt-3">
                                {event.ref}
                            </p>
                        </motion.div>
                    )}

                    {/* Toggle button */}
                    <button
                        onClick={() => setExpanded(!expanded)}
                        className={`mt-2 flex items-center gap-2 text-xs font-semibold text-white px-4 py-2 rounded-sm transition-all duration-200 ${c.btn}`}
                    >
                        {expanded ? "Show Less" : "Read More"}
                        <svg
                            className={`w-3.5 h-3.5 transition-transform duration-300 ${expanded ? "rotate-180" : ""}`}
                            fill="none" stroke="currentColor" strokeWidth={2.5} viewBox="0 0 24 24"
                        >
                            <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                        </svg>
                    </button>
                </div>
            </div>

            {/* Spacer for opposite side */}
            <div className="hidden md:block md:w-[54%]" />
        </motion.div>
    );
}

const YearlyEvents = () => {
    return (
        <div className="w-[100%]">

            {/* ── Hero ── */}
            <div className="relative w-full h-[40vh] md:h-[50vh] mt-32 md:mt-36 overflow-hidden">
                <img
                    src="https://firebasestorage.googleapis.com/v0/b/bcs-public-portal.appspot.com/o/BCS_WEBITE_ASSETS%2Fsye.jpg?alt=media&token=34b4c208-514b-4763-bb20-15c98d145706"
                    alt="Standard Yearly Events"
                    className="w-full h-full object-cover object-center"
                />
             
            </div>

            <div className="max-w-5xl mx-auto px-5 md:px-10 py-16">

                {/* Section label */}
                <div className="flex items-center gap-2 mb-4">
                    <span className="block w-7 h-px bg-blue-600" />
                    <span className="text-blue-600 text-xs font-semibold tracking-widest uppercase">
                        Annual Calendar
                    </span>
                </div>
                <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
                    Our Sacred Events
                </h2>
                <p className="text-gray-400 text-sm mb-16 max-w-xl leading-relaxed">
                    Brotherhood of the Cross and Star is a global divine institution teaching Universal love, peace, unity, truth and righteousness in the Holy Spirit. These events are observed faithfully every year across all Bethels worldwide.
                </p>

                {/* ── Timeline ── */}
                <div className="relative">

                    {/* Center vertical line — desktop */}
                    <div className="hidden md:block absolute left-1/2 -translate-x-1/2 top-0 bottom-0 w-px bg-gray-100" />

                    {yearlyEvents.map((event, index) => (
                        <EventCard key={event.id} event={event} index={index} />
                    ))}

                    {/* End cap */}
                    <div className="flex flex-col items-center mt-4 gap-2">
                        <div className="w-px h-8 bg-gray-100" />
                        <div className="w-3 h-3 rounded-full bg-gray-300" />
                        <p className="text-xs text-gray-400 tracking-widest uppercase mt-1">
                            Every Year, Without Fail
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default YearlyEvents;